<template src="./template.html"></template>

<style scoped lang="scss"> @import "style"; </style>

<script>
  import Crop from "./Crop";
  import {ValidationObserver, ValidationProvider} from "vee-validate";
  import ImageTools from "@/util/ImageTools";

  export default {
    props: {
      disabled:{
        type: Boolean,
        default: false
      },
      transparent: {
        type: Boolean,
        default: false
      },
      onSelectedPicture: {
        type: Function
      },
      onSelectedVideo: {
        type: Function
      },
      errors: {
        type: Object,
        default: () => {
        }
      },
      accept: {
        type: String,
        default: 'image/png, image/jpeg, image/jpg'
      },
      placeholder: {
        type: String,
        default: 'Image'
      },
      prependIcon: {
        type: String,
        default: 'fas fa-camera'
      },
      label: {
        type: String,
        default: ''
      },
      multiple: {
        type: Boolean,
        default: false
      },
      defaultMessage: {
        type: String,
        default: "Drop an image here or click to upload"
      }
    },
    name: 'Upload',
    created() {
    },
    computed: {},
    data() {
      return {
        selectedFile: null,
        showCrop: false
      }
    },
    methods: {
      onSuccess(file) {
        this.closeCrop();
        if (this.onSelectedPicture) {
          const imageTools = new ImageTools();
          imageTools.resize(file, {width: 1000, height: 1000}).then((blob) => {
            let URLObj = window.URL || window.webkitURL;
            let source = URLObj.createObjectURL(file);
            this.onSelectedPicture(blob, source);
          });
        } else if (this.onSelectedVideo) {
          let URLObj = window.URL || window.webkitURL;
          let source = URLObj.createObjectURL(file);
          this.onSelectedVideo(file, source);
        }
      },
      selectPicture(file) {
        const self = this;
        if (file instanceof Blob || file instanceof File) {
          if (this.onSelectedPicture) {
            this.showCrop = true;

            const reader = new FileReader();
            reader.addEventListener(
              "load",
              function () {
                self.selectedFile = reader.result;
                self.showCrop = true;
              },
              false
            );
            reader.readAsDataURL(file);
          } else if (this.onSelectedVideo) {
            let URLObj = window.URL || window.webkitURL;
            let source = URLObj.createObjectURL(file);
            this.onSelectedVideo(file, source);
          }
        }
      },
      closeCrop() {
        this.showCrop = false;
      },
      selectPictureFromInput(event) {
        for (let i in event.target.files) {
          let file = event.target.files[i];
          this.selectPicture(file);
        }
      },
      addFiles(event) {
        for (let i in event.target.files) {
          let file = event.target.files[i];
          this.selectPicture(file);
        }
      },
      dragover(event) {
        event.preventDefault();
        // Add some visual fluff to show the user can drop its files
        if (!event.currentTarget.classList.contains('success')) {
          event.currentTarget.classList.remove('gray');
          event.currentTarget.classList.add('success');
        }
      },
      dragleave(event) {
        // Clean up
        event.currentTarget.classList.add('gray');
        event.currentTarget.classList.remove('success');
      },
      drop(event) {
        event.preventDefault();

        event.currentTarget.classList.remove('success');
        event.currentTarget.classList.add('gray');

        for (let i in event.dataTransfer.files) {
          let file = event.dataTransfer.files[i];
          this.selectPicture(file);
        }
      },
    },
    components: {
      ValidationProvider,
      ValidationObserver,
      Crop
    },
  }
  ;
</script>
